import { Component, Inject, OnInit } from '@angular/core';
import { FilterSelectItem } from '../filter-lab-sample.service';
import { ConfigurationItem } from 'diwimamodelweb/lib';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GrMultiSelectFilterDialogComponent {
  ref: FilterSelectItem
}

@Component({
  selector: 'app-lab-sample-multi-select-filter-dialog',
  templateUrl: './lab-sample-multi-select-filter-dialog.component.html',
  styleUrls: ['./lab-sample-multi-select-filter-dialog.component.css']
})

export class LabSampleMultiSelectFilterDialogComponent implements OnInit {
  selectedOptions: [{selected: boolean, item: ConfigurationItem}]

  constructor(
    public dialogRef: MatDialogRef<LabSampleMultiSelectFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LabSampleMultiSelectFilterDialogComponent,
  ) { }

  ngOnInit(): void {}

  getTitle(item: ConfigurationItem) {
    if (item.title) return item.title
    else return item.names?.de
  }

  onAreaListControlChanged(list) {
    this.data['ref'].setActiveFilter(list.selectedOptions.selected.map(el => el.value))
  }

}